import Layout from '@layout/Index'

export const fairReward = [
  {
    path: '/fair_reward',
    component: Layout,
    children: [
      {
        path: 'table/:fairid',
        component: () => import(/* webpackChunkName: "FairRewardTable" */'./pages/FairRewardTable.vue'),
        name: '获奖记录',
        meta: {
          title: '获奖记录',
        },
      },
      {
        path: 'form/:id',
        component: () => import(/* webpackChunkName: "FairRewardUpdate" */'./pages/FairRewardUpdate.vue'),
        name: '填写物流',
        meta: {
          title: '填写物流',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "FairRewardUpdate" */'./pages/FairRewardUpdate.vue'),
        name: '修改物流',
        meta: {
          title: '修改物流',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/fair-reward/fairReward.route.js